// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import {
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, updateProfile, sendEmailVerification,
} from 'firebase/auth';

import {
  getDatabase, ref, onValue, query, orderByChild, limitToFirst, limitToLast, equalTo, get, child, update,
} from 'firebase/database';

// Staging config
const firebaseConfig = {
  apiKey: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_API_KEY : process.env.REACT_APP_PROD_API_KEY,
  authDomain: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_AUTH_DOMAIN : process.env.REACT_APP_PROD_AUTH_DOMAIN,
  databaseURL: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_DB_URL : process.env.REACT_APP_PROD_DB_URL,
  projectId: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_PROJECT_ID : process.env.REACT_APP_PROD_PROJECT_ID,
  storageBucket: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_STORAGE_BUCKET : process.env.REACT_APP_PRD_STORAGE_BUCKET,
  messagingSenderId: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MSG_SENDER_ID : process.env.REACT_APP_PROD_MSG_SENDER_ID,
  appId: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_APP_ID : process.env.REACT_APP_PROD_APP_ID,
  measurementId: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MEASUREMENT_ID : process.env.REACT_APP_PROD_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export {
  app,
  analytics,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  updateProfile,
  sendEmailVerification,
  getDatabase,
  ref,
  onValue,
  query,
  orderByChild,
  limitToFirst,
  limitToLast,
  equalTo,
  get,
  child,
  update,
};
